import { Product } from "@dreamhub/designsystem/icons";
import { getMilestoneBorderColors } from "@/components/shared/Milestones";
import IconContainer, { iconSize } from "@/components/ui/icon-container";
import { cn } from "@/utils/utils";
import React, { ReactNode } from "react";

export interface LogoIconContainerProps {
  index?: number;
  className?: string;
  innerClassName?: string;
  icon?: ReactNode;
  iconSize?: iconSize;
  variant?: "default" | "danger" | "warning" | "defaultGray";
  /** Override the inner fill color (border is unaffected). */
  bgColor?: string;
}

const LogoIconContainer: React.FC<LogoIconContainerProps> = ({
  index = 0,
  className = "",
  innerClassName = "",
  icon,
  iconSize = "md",
  variant = "default",
  bgColor
}) => {
  const isDanger = variant === "danger";
  const isWarning = variant === "warning";
  const isDefaultGray = variant === "defaultGray";

  const milestoneBorderColors = getMilestoneBorderColors();
  const milestoneColor =
    milestoneBorderColors[index % milestoneBorderColors.length];

  const baseColor = isDanger
    ? "var(--surface-logo-danger)"
    : isWarning
      ? "var(--surface-logo-warning)"
      : index === -1
        ? "var(--grey-750)"
        : milestoneColor;

  const gradientOverlay = `linear-gradient(180deg, var(--surface-logo-overlay-start) 0%, var(--surface-logo-overlay-end) 100%)`;

  // No ring for warning, or danger off index -1: their old strings were invalid CSS.
  const borderGradient = isWarning
    ? undefined
    : index === -1
      ? "linear-gradient(45deg, var(--border-logo-default-start) 0%, var(--border-logo-default-end) 100%)"
      : isDanger
        ? undefined
        : `linear-gradient(45deg, ${milestoneColor}50 0%, ${milestoneColor}FF 100%)`;

  const iconColor = isDanger
    ? "negative"
    : isWarning
      ? "warning"
      : isDefaultGray
        ? "disabled"
        : "white";

  return (
    <div
      className={cn(
        "w-10 h-10 shrink-0 flex items-center justify-center rounded-[12px] p-[1px] relative",
        className
      )}
      style={{
        background: borderGradient
      }}
    >
      <div
        className={cn(
          "w-full h-full flex items-center justify-center rounded-[12px]",
          innerClassName
        )}
        style={{
          backgroundColor: bgColor ?? baseColor,
          //todo: this should be on a different layer , start with the color, then the gradientOverlay and then borderGradient
          backgroundImage: gradientOverlay
        }}
      >
        <IconContainer
          size={iconSize}
          color={iconColor}
          className="[&>svg]:size-full"
        >
          {icon ? icon : <Product />}
        </IconContainer>
      </div>
    </div>
  );
};

export default LogoIconContainer;
